<template>
  <div>
    <div v-if="show && shouldShowBanner" class="tax-banner">
      <button
        v-if="closable"
        @click="closeBanner"
        class="tax-banner-close"
        type="button"
        aria-label="Close banner"
      >
        <svg
          class="tax-banner-close-icon"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M6 18L18 6M6 6l12 12"
          />
        </svg>
      </button>
      <div class="tax-banner-content">
        <div class="tax-banner-left">
          <div class="tax-banner-icon">
            <img alt="Notification Bell" src="/img/notification-bell.png" />
          </div>
          <div class="tax-banner-text">
            <h3 class="tax-banner-title">
              {{ mostRecentMessage.title }}
            </h3>
            <p class="tax-banner-message">
              {{ mostRecentMessage.message }}
            </p>
            <p class="tax-banner-date">ON: {{ displayDate | humanDate }}</p>
          </div>
        </div>
        <div class="tax-banner-action">
          <v-btn
            @click="applyTaxes()"
            :loading="progress"
            class="tax-apply-btn"
            depressed
          >
            Apply Taxes
          </v-btn>
        </div>
      </div>
    </div>

    <v-dialog persistent width="500" v-model="applied">
      <v-card>
        <v-card-title>Taxes Applied</v-card-title>
        <v-card-text>
          <h3 class="font-weight-light">
            These taxes were added to your sales taxes
          </h3>

          <v-list v-if="appliedtaxes">
            <v-list-item v-for="tax in appliedtaxes" :key="tax.id">
              <v-list-item-content>
                <v-list-item-title>{{ tax.name }}</v-list-item-title>
                <v-list-item-subtitle>{{
                  tax.display_name
                }}</v-list-item-subtitle>
              </v-list-item-content>

              <v-list-item-icon>
                <v-icon color="green">mdi-check</v-icon>
              </v-list-item-icon>
            </v-list-item>
          </v-list>
        </v-card-text>
        <v-card-actions>
          <v-btn block color="blue darken-4" dark @click="done()">Okay</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: "NewTaxesAnnouncement",
  props: {
    closable: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      message: null,
      show: false,
      progress: false,
      appliedtaxes: null,
      applied: false,
      isClosed: false,
    };
  },
  computed: {
    mostRecentMessage() {
      if (
        !this.message ||
        !this.message.message ||
        !Array.isArray(this.message.message)
      ) {
        return {};
      }

      const sortedMessages = [...this.message.message].sort((a, b) => {
        const dateA = new Date(a.created_at);
        const dateB = new Date(b.created_at);
        return dateB - dateA;
      });

      return sortedMessages[0] || {};
    },
    displayDate() {
      if (!this.mostRecentMessage.created_at) {
        return null;
      }
      const date = new Date(this.mostRecentMessage.created_at);
      date.setDate(date.getDate() + 1);
      return date.toISOString();
    },
    shouldShowBanner() {
      if (!this.closable) return true;
      return !this.isClosed;
    },
  },
  methods: {
    getTaxNotification() {
      axios.get("/api/newtaxes").then((res) => {
        this.message = res.data;
        this.show = res.data.show;
        this.$nextTick(() => {
          if (this.closable && this.mostRecentMessage && this.mostRecentMessage.id) {
            const isClosed = localStorage.getItem(
              `taxBannerClosed_${this.mostRecentMessage.id}`
            );
            if (isClosed === "true") {
              this.isClosed = true;
            }
          }
        });
      });
    },

    applyTaxes() {
      this.progress = true;
      axios.get("/api/applynewtaxes").then((res) => {
        this.appliedtaxes = res.data;
        this.applied = true;
        this.progress = false;
      });
    },
    done() {
      window.location.reload();
    },
    closeBanner() {
      this.isClosed = true;
      if (this.mostRecentMessage && this.mostRecentMessage.id) {
        localStorage.setItem(
          `taxBannerClosed_${this.mostRecentMessage.id}`,
          "true"
        );
      }
    },
  },
  mounted() {
    this.getTaxNotification();
  },
  watch: {
    mostRecentMessage(newVal) {
      if (!this.closable) return;
      if (newVal && newVal.id) {
        const isClosed = localStorage.getItem(`taxBannerClosed_${newVal.id}`);
        if (isClosed === "true") {
          this.isClosed = true;
        } else {
          this.isClosed = false;
        }
      }
    },
  },
};
</script>

<style scoped>
.tax-banner {
  background: #e1f5fe;
  border: 1px solid #b2dfdb;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  border-radius: 12px;
  padding: 24px;
  margin-bottom: 16px;
  margin-left: 16px;
  margin-right: 16px;
  position: relative;
}

@media (min-width: 640px) {
  .tax-banner {
    margin-left: 24px;
    margin-right: 24px;
  }
}

.tax-banner-content {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
}

@media (min-width: 768px) {
  .tax-banner-content {
    flex-direction: row;
    align-items: center;
  }
}

.tax-banner-left {
  display: flex;
  align-items: center;
  gap: 16px;
  flex: 1;
  min-width: 0;
  width: 100%;
}

@media (min-width: 768px) {
  .tax-banner-left {
    width: auto;
  }
}

.tax-banner-icon {
  flex-shrink: 0;
}

.tax-banner-icon img {
  width: 64px;
  height: 64px;
  mix-blend-mode: multiply;
  border-radius: 50%;
  object-fit: contain;
}

.tax-banner-text {
  flex: 1;
  min-width: 0;
}

.tax-banner-title {
  font-weight: 700;
  color: #111827;
  line-height: 1.5;
  margin-bottom: 2px;
  font-size: 20px;
}

.tax-banner-message {
  color: #374151;
  font-size: 14px;
  margin-bottom: 4px;
  line-height: 1.5;
}

.tax-banner-date {
  color: #888;
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  margin: 0;
}

.tax-banner-action {
  flex-shrink: 0;
  width: 100%;
  margin-top: 16px;
}

@media (min-width: 768px) {
  .tax-banner-action {
    width: auto;
    margin-top: 0;
    margin-left: 24px;
  }
}

.tax-apply-btn {
  background-color: #388e3c !important;
  color: white !important;
  border-radius: 6px;
  padding: 10px 20px;
  font-weight: 500;
  font-size: 14px;
  text-transform: none;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  transition: background-color 0.15s ease-in-out;
}

.tax-apply-btn:focus {
  outline: none;
  box-shadow: 0 0 0 3px rgba(56, 142, 60, 0.2);
}

.tax-banner-close {
  position: absolute;
  top: -8px;
  right: -8px;
  background: white;
  border: 1px solid #e5e7eb;
  border-radius: 50%;
  cursor: pointer;
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #6b7280;
  transition: all 0.15s ease-in-out;
  z-index: 1;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  width: 24px;
  height: 24px;
}

.tax-banner-close:hover {
  color: #111827;
  background: #f9fafb;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);
}

.tax-banner-close:focus {
  outline: none;
  color: #111827;
}

.tax-banner-close-icon {
  width: 14px;
  height: 14px;
}
</style>
